import React from 'react'
import map from 'lodash/map'
import _, { reduce } from 'lodash'
import { List } from 'immutable'

import { getCdnHost, CloudResourceType } from '../lib/env-variables'

const option = (label, value) => ({ label, value })

const toOpt = (value) => ({ value, label: value })

export const fontList = {
  'Abril Fatface': "'Abril Fatface', cursive;",
  Alef: "'Alef', sans-serif;",
  Arial: "Arial, 'Helvetica Neue', Helvetica, sans-serif;",
  'Arial Black': "'Arial Black', 'Arial Bold', Gadget, sans-serif;",
  'Arial Narrow': "'Arial Narrow', Arial, sans-serif;",
  Consolas: 'Consolas, monaco, monospace;',
  'Courier New': "'Courier New', Courier, 'Lucida Sans Typewriter', 'Lucida Typewriter', monospace;",
  'DM Sans': " 'DM Sans', sans-serif;",
  Georgia: "Georgia, Times, 'Times New Roman', serif;",
  Impact:
    "Impact, Haettenschweiler, 'Franklin Gothic Bold', Charcoal, 'Helvetica Inserat', 'Bitstream Vera Sans Bold', 'Arial Black', sans serif;",
  'Josefin Slab': " 'Josefin Slab', serif;",
  'Lucida Bright': "'Lucida Bright', Georgia, serif;",
  'Lucida Grande': "'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Geneva, Verdana, sans-serif;",
  Monaco: "Monaco, Consolas, 'Lucida Console', monospace;",
  Muli: "'Muli', sans-serif;",
  'Open Sans Hebrew': "'Open Sans', sans-serif;",
  'Old Standard TT': " 'Old Standard TT', serif;",
  Tahoma: 'Tahoma;',
  Helvetica: 'Helvetica;',
  'Times New Roman': 'Times New Roman;',
  Verdana: 'Verdana;',
  Alegreya: "'Alegreya', serif;",
  'Alegreya Sans': "'Alegreya Sans', sans-serif;",
  'Amatic SC': "'Amatic SC', cursive;",
  'Anonymous Pro': "'Anonymous Pro', monospace;",
  Archivo: "'Archivo', sans-serif;",
  'Archivo Narrow': "'Archivo Narrow', sans-serif;",
  Arimo: "'Arimo', sans-serif;",
  Arvo: "'Arvo', serif;",
  Asap: "'Asap', sans-serif;",
  Assistant: "'Assistant', sans-serif;",
  'Bad Script': "'Bad Script', cursive;",
  BioRhyme: "'BioRhyme', serif;",
  'Brush Script MT': '"Brush Script MT", cursive;',
  Cabin: "'Cabin', sans-serif;",
  Cairo: "'Cairo', sans-serif;",
  Cardo: "'Cardo', serif;",
  Chivo: "'Chivo', sans-serif;",
  Cormorant: "'Cormorant', serif;",
  'Crafty Girls': "'Crafty Girls', cursive;",
  'Crimson Text': "'Crimson Text', serif;",
  'Dancing Script': "'Dancing Script', cursive;",
  Domine: "'Domine', serif;",
  Eczar: "'Eczar', serif;",
  'Exo 2': "'Exo 2', sans-serif;",
  Felipa: "'Felipa', cursive;",
  'Fira Sans': "'Fira Sans', sans-serif;",
  'Frank Ruhl Libre': "'Frank Ruhl Libre', serif;",
  Heebo: "'Heebo', sans-serif;",
  'IBM Plex Sans': "'IBM Plex Sans', sans-serif;",
  Inconsolata: "'Inconsolata', monospace;",
  'Inknut Antiqua': "'Inknut Antiqua', serif;",
  Karla: "'Karla', sans-serif;",
  Lato: "'Lato', sans-serif;",
  'Libre Baskerville': "'Libre Baskerville', serif;",
  'Libre Franklin': "'Libre Franklin', sans-serif;",
  Lora: "'Lora', serif;",
  'M PLUS Rounded 1c': "'M PLUS Rounded 1c', sans-serif;",
  Merriweather: "'Merriweather', serif;",
  'Miriam Libre': "'Miriam Libre', sans-serif;",
  Montserrat: "'Montserrat', sans-serif;",
  Mulish: "'Mulish', sans-serif;",
  Neuton: "'Neuton', serif;",
  Niconne: "'Niconne', cursive;",
  'Noto Serif': "'Noto Serif', serif;",
  'Noto Sans': "'Noto Sans', sans-serif",
  Nunito: "'Nunito', sans-serif;",
  'Open Sans': "'Open Sans', sans-serif;",
  Oswald: "'Oswald', sans-serif;",
  Oxygen: "'Oxygen', sans-serif;",
  Pacifico: "'Pacifico', cursive;",
  Parisienne: "'Parisienne', cursive;",
  'Playfair Display': "'Playfair Display', serif;",
  Poppins: "'Poppins', sans-serif;",
  'Proza Libre': "'Proza Libre', sans-serif;",
  'PT Sans': "'PT Sans', sans-serif;",
  'PT Serif': "'PT Serif', serif;",
  Raleway: "'Raleway', sans-serif;",
  Roboto: "'Roboto', sans-serif;",
  'Roboto Slab': "'Roboto Slab', serif;",
  Rubik: "'Rubik', sans-serif;",
  Sacramento: "'Sacramento', cursive;",
  'Shadows Into Light Two': "'Shadows Into Light Two', cursive;",
  'Source Sans Pro': "'Source Sans Pro', sans-serif;",
  'Source Serif Pro': "'Source Serif Pro', serif;",
  'Space Mono': "'Space Mono', monospace;",
  Spectral: "'Spectral', serif;",
  'Titillium Web': "'Titillium Web', sans-serif;",
  Ubuntu: "'Ubuntu', sans-serif;",
  Varela: "'Varela', sans-serif;",
  'Varela Round': "'Varela Round', sans-serif;",
  Vollkorn: "'Vollkorn', serif;",
  'Work Sans': "'Work Sans', sans-serif;",
  'Salesforce Sans': 'SalesforceSans;',
  'Open Sans': "'Open Sans', sans-serif;",
}
export const includeBuilderFontStyle = () => {
  if (!document.getElementById(`build_google_fonts`)) {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = getBuilderFontLink()
    link.id = 'build_google_fonts'
    link.crossorigin = 'anonymous'
    document.body.appendChild(link)
  }
}

export const customFontsList = fontList
export const getBuilderFontLink = function () {
  return 'https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Cairo:wght@200;400;500;600;700;800&family=Exo:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600&family=Cormorant:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&family=Alef&family=DM+Sans&family=Heebo&family=Josefin+Slab&family=Libre+Baskerville&family=Miriam+Libre&family=Montserrat&family=Mulish&family=Neuton&family=Niconne&family=Nunito&family=Old+Standard+TT&family=Open+Sans&family=Oswald&family=PT+Sans&family=PT+Serif&family=Pacifico&family=Parisienne&family=Playfair+Display&family=Poppins&family=Proza+Libre&family=Raleway&family=Roboto&family=Roboto+Slab&family=Rubik&family=Sacramento&family=Shadows+Into+Light+Two&family=Source+Sans+Pro&family=Source+Serif+Pro&family=Space+Mono&family=Spectral&family=Titillium+Web&family=Ubuntu&family=Varela&family=Varela+Round&family=Vollkorn&family=Work+Sans&display=swap&family=Noto+Sans&display=swap'
}
export const getBuilderFontLink2 = function () {
  return 'https://fonts.googleapis.com/css2?family:Andale+Mono&family:Arial&family:Arial+Black&family:Arial+Narrow&family:Arial+Rounded+MT+Bold&family=Cairo:wght@200;400;500;600;700;800&family=Exo:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600&family=Cormorant:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&family:Avant+Garde&family:Baskerville&family:Big+Caslon&family:Bodoni+MT&family:Book+Antiqua&family:Brush+Script+MT&family:Calisto+MT&family:Cambrio&family:Century+Gothic&family:Candara&family:Consolas&family:Copperplate&family:Courier+New&family:Didot&family:Droid+Sans&family:FB+Reforma&family:Franklin+Gothic+Medium&family:Futura&family:Garamond&family:Georgia&family:Geneva&family:Gill+Sans&family:Goudy+Old+Style&family:Hoefler+Text&family:Impact&family:Lucida+Bright&family:Lucida+Console&family:Lucida+Sans+Typewriter&family:Lucida+Grande&family:Monaco&family:Muli&family:Open+Sans+Hebrew&family:Open+Sans+Hebrew+Condensed&family:Optima&family:Palatino&family:Papyrus&family:Perpetua&family:Rockwell&family:Rockwell+Extra+Bold&family:Trebuchet+MS'
}

export const fontFamily = [
  'Arial',
  'Helvetica',
  'Times New Roman',
  'Times',
  'Courier New',
  'Courier',
  'Verdana',
  'Palatino',
  'Garamond',
  'Bookman',
  'Comic Sans MS',
  'Trebuchet MS',
  'Arial Black',
  'Impact',
]

export const safeWebFonts = {
  Arial: "Arial, 'Helvetica Neue', Helvetica, sans-serif",
  Verdana: 'Verdana',
  Tahoma: 'Tahoma',
  'Trebuchet MS': 'Trebuchet MS',
  'Times New Roman': 'Times New Roman',
  Georgia: "Georgia, Times, 'Times New Roman', serif",
  Garamond: 'Garamond',
  'Courier New': 'Courier New',
}

export const emailFontFamilyOptions = [{ value: '', label: 'Select' }].concat(
  _.sortBy(
    reduce(safeWebFonts, (ret, val, key) => [...ret, option(key, val)], []),
    'label'
  )
)

export const previewEmailFontFamilyOptions = _.map(emailFontFamilyOptions, ({ label, value }) =>
  option(<span style={{ fontFamily: label }}>{label}</span>, value)
)

export const getCustomFontList = (state) =>
  state
    .getIn(['project', 'Settings', 'customFonts'], List())
    .filter((font) => font.get('fontSource') === 'custom')
    .map((font) => option(font.get('label'), font.get('value')))

export const fontFamilyOptions = [{ value: '', label: 'Select' }].concat(
  _.sortBy(
    reduce(fontList, (ret, val, key) => [...ret, option(key, val)], []),
    'label'
  )
)

export const previewFontFamilyOptions = _.map(fontFamilyOptions, ({ label, value }) =>
  option(<span style={{ fontFamily: label }}>{label}</span>, value)
)

export const VIEWPORT_UNITS = ['lvh', 'lvw', 'svh', 'svw', 'dvh', 'dvw']
export const CSS_UNITS_OPTIONS = map(
  ['px', 'em', 'rem', '%', 'calc', 'fr', 'vw', 'vh', 'deg', ...VIEWPORT_UNITS],
  (opt) => toOpt(opt, opt)
)
export const REDIRECT_UNITS_OPTIONS = map(['px', 'em', 'rem', '%', ...VIEWPORT_UNITS], (opt) => toOpt(opt, opt))
export const FLEX_STRIP_CSS_UNITS_OPTIONS = map(['px', 'em', 'rem', 'vh', ...VIEWPORT_UNITS], (opt) => toOpt(opt, opt))

export const ALIGN_OPTIONS = [
  { label: 'Select', value: '' },
  { label: 'Left', value: 'left' },
  { label: 'Center', value: 'center' },
  { label: 'Right', value: 'right' },
]
export const FLEX_ALIGN_OPTIONS = [
  { label: 'Left', value: 'start' },
  { label: 'Center', value: 'center' },
  { label: 'Right', value: 'end' },
]

export const BG_SIZE_OPTIONS = [option('Auto', 'auto'), option('Contain', 'contain'), option('Cover', 'cover')]

export const FLEX_POSITION_OPTIONS = [
  option('Left', 'flex-start'),
  option('Center', 'center'),
  option('Right', 'flex-end'),
]

export const BG_CLIP_OPTIONS = [
  option('border-box', 'border-box'),
  option('padding-box', 'padding-box'),
  option('content-box', 'content-box'),
  option('text', 'text'),
  option('unset', 'unset'),
]

export const BD_REPEAT_OPTIONS = [
  option('inherit', 'inherit'),
  option('repeat', 'repeat'),
  option('no-repeat', 'no-repeat'),
  option('repeat-x', 'repeat-x'),
  option('repeat-y', 'repeat-y'),
]

export const BG_ATTACH_OPTIONS = [
  option('scroll', 'scroll'),
  option('fixed', 'fixed'),
  option('local', 'local'),
  option('inherit', 'inherit'),
  option('initial', 'initial'),
]

export const COLOR_PICKER_ICON = function ({ color: colorProvided = 'transparent', ...rest }) {
  let color = colorProvided ? colorProvided : 'transparent'
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="24"
      viewBox="0 0 18 24"
      style={{ fill: color }}
      {...rest}>
      <path
        stroke="#B8B8B8"
        d="M1 15.043C1 10.65 9.038 1 9.038 1s8.039 9.649 8.039 14.043c0 4.395-3.599 7.957-8.039 7.957C4.598 23 1 19.438 1 15.043z"
      />
    </svg>
  )
}

export const FONT_STYLE_OPTIONS = [
  option('Select', ''),
  option(<span style={{ fontWeight: 'lighter' }}>Lighter</span>, 'lighter'),
  option(<span style={{ fontWeight: 'normal' }}>Normal</span>, 'normal'),
  option(<b>Bold</b>, 'bold'),
  option(<span style={{ fontWeight: 'bolder' }}>Bolder</span>, 'bolder'),
  option(<span style={{ fontWeight: 300 }}>300</span>, '300'),
  option(<span style={{ fontWeight: 500 }}>500</span>, '500'),
]

const CDN_HOST_FORM_PREVIEWS = getCdnHost(CloudResourceType.FORM_PREVIEWS)
const REACT_APP_WEB_CDN = `https://${CDN_HOST_FORM_PREVIEWS}/ftwebproject/test`

export const STATIC_SF_FONT = `@font-face {
  font-family: 'SalesforceSans';
  font-style: normal;
  font-weight: 400;
  src: url("${REACT_APP_WEB_CDN}/fonts/SalesforceSans/SalesforceSans-Regular.woff2") format('woff2'),
      url("${REACT_APP_WEB_CDN}/fonts/SalesforceSans/SalesforceSans-Regular.woff") format('woff');
}
@font-face {
  font-family: 'SalesforceSans';
  font-style: italic;
  font-weight: 100;
  src: url("${REACT_APP_WEB_CDN}/fonts/SalesforceSans/SalesforceSans-ThinItalic.woff2") format('woff2'),
      url("${REACT_APP_WEB_CDN}/fonts/SalesforceSans/SalesforceSans-ThinItalic.woff") format('woff');
}
@font-face {
  font-family: 'SalesforceSans';
  font-style: italic;
  font-weight: 300;
  src: url("${REACT_APP_WEB_CDN}/fonts/SalesforceSans/SalesforceSans-LightItalic.woff2") format('woff2'),
      url("${REACT_APP_WEB_CDN}/fonts/SalesforceSans/SalesforceSans-LightItalic.woff") format('woff');
}
@font-face {
  font-family: 'SalesforceSans';
  font-style: italic;
  font-weight: 400;
  src: url("${REACT_APP_WEB_CDN}/fonts/SalesforceSans/SalesforceSans-Italic.woff2") format('woff2'),
      url("${REACT_APP_WEB_CDN}/fonts/SalesforceSans/SalesforceSans-Italic.woff") format('woff');
}
@font-face {
  font-family: 'SalesforceSans';
  font-style: normal;
  font-weight: 100;
  src: url("${REACT_APP_WEB_CDN}/fonts/SalesforceSans/SalesforceSans-Thin.woff2") format('woff2'),
      url("${REACT_APP_WEB_CDN}/fonts/SalesforceSans/SalesforceSans-Thin.woff") format('woff');
}
@font-face {
  font-family: 'SalesforceSans';
  font-style: normal;
  font-weight: 300;
  src: url("${REACT_APP_WEB_CDN}/fonts/SalesforceSans/SalesforceSans-Light.woff2") format('woff2'),
      url("${REACT_APP_WEB_CDN}/fonts/SalesforceSans/SalesforceSans-Light.woff") format('woff');
}
@font-face {
  font-family: 'SalesforceSans';
  font-style: normal;
  font-weight: bold;
  src: url("${REACT_APP_WEB_CDN}/fonts/SalesforceSans/SalesforceSans-Bold.woff2") format('woff2'),
      url("${REACT_APP_WEB_CDN}/fonts/SalesforceSans/SalesforceSans-Bold.woff") format('woff');
}`
